/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-10-12 07:17:47
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-01-09 10:37:32
 * @FilePath     : /marketing-introduce-ssr/pages/index.tsx
 * @Description  : 未添加文件描述
 */

import PageLoading from '@/components/PageLoading';

export const Home = (): JSX.Element => {
  return <PageLoading status='fail' title='活动已结束' content='活动已结束' />;
};

export default Home;
